import * as React from 'react';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { Icon } from 'ui/common/icon';
import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import { BadgeList } from 'ui/badge-list';
import { FactItemProps } from 'app/area/case/components/fact-box/types';
import { ChildEntityCountShape } from 'app/area/case/selectors';
import { ComponentProps } from 'ui/common';
import { isCaseViewModalOpen } from 'app/components/helpers';

interface FactItemCommentsProps extends ComponentProps, FactItemProps {
  numberOfComments: ChildEntityCountShape;
}

export const CommentsFactItem = (props: FactItemCommentsProps) => {
  const { tooltip, title, numberOfComments, url, linkDomain, portalTarget } = props;
  const iconAbsolutPath = toAbsoluteUrl('i/comments.svg');
  const iconComments = <Icon url={iconAbsolutPath} />;
  const items = [
    { value: numberOfComments?.count, tooltip }
  ];

  if(!numberOfComments?.count){
    return null;
  }
  return <FactLink id={props.componentId} classNames="fact-item" section={linkDomain} url={url} skipNavigation={isCaseViewModalOpen()}>
    <BadgeList
      icon={iconComments}
      title={title}
      valueItems={items}
      portalTarget={portalTarget}
    />
  </FactLink>;
};
